/*
 * File: appSlice.ts
 * Project: beaker
 * -----
 * Last Modified: 15 Mar 2022 10:34:41 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import { AppState } from 'models/Application';

// Get theme from cookies or default to dark
const getInitialTheme = (): 'dark' | 'light' => {
  const savedTheme = Cookies.get('theme');
  return savedTheme === 'light' || savedTheme === 'dark' ? savedTheme : 'light';
};

const initialState: AppState = {
  showLoader: false,
  application: null,
  user: null,
  acuityContext: null,
  accessToken: null,
  company: null,
  internalAppState: undefined,
  theme: getInitialTheme() // Use the function to get initial theme
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    showLoader(state, action: PayloadAction<AppState['showLoader']>): void {
      state.showLoader = action.payload;
    },
    setUser(state, action: PayloadAction<AppState['user']>): void {
      state.user = action.payload;
    },
    setAcuityContext(state, action: PayloadAction<AppState['acuityContext']>): void {
      state.acuityContext = action.payload;
    },
    setAccessToken(state, action: PayloadAction<AppState['accessToken']>) {
      state.accessToken = action.payload;
    },
    setInternalAppState(state, action: PayloadAction<AppState['internalAppState']>) {
      state.internalAppState = action.payload;
    },
    setCompany(state, { payload }: PayloadAction<AppState['company']>) {
      state.company = payload;
    },
    toggleTheme(state) {
      state.theme = state.theme === 'dark' ? 'light' : 'dark';
      // Save theme preference to cookies (expires in 365 days)
      Cookies.set('theme', state.theme, { expires: 365 });
    }
  }
});

export const { showLoader: setLoader, setUser, setAcuityContext, setAccessToken, setCompany, setInternalAppState, toggleTheme } = appSlice.actions;
